/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useEffect, useState } from "react";
import useStateRef from "react-usestateref";

interface IFields {
  [key: string]: {
    state: "initial" | "success";
    value: string;
  };
}

const useGuestOptions = (options: string[]) => {
  const initFields = () => {
    const fields = {};
    options?.forEach((option) => {
      // @ts-ignore
      fields[option] = { state: "initial", value: option };
    });
    return fields;
  };
  const [, setFields, { current: fields }] = useStateRef<IFields>(() =>
    initFields()
  );
  useEffect(() => {
    // [option]: { state: "initial", value: [option] },
    const fields = initFields();
    setFields(fields);
  }, []);
  const handleOnChange = (field: string, state?: "initial" | "success") => {
    if (!state) {
      setFields((prev) => ({
        ...prev,
        [field]: { ...prev[field], state: "initial" },
      }));
    } else {
      setFields((prev) => ({
        ...prev,
        [field]: { ...prev[field], state: state },
      }));
    }
  };
  const handleResetAll = () => {
    const fields = {};
    options.forEach((option) => {
      // @ts-ignore
      fields[option] = { state: "initial", value: option };
    });
    setFields(fields);
  };
  return [fields, setFields, handleResetAll];
};

export default useGuestOptions;
